import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { forkJoin, NEVER, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { PreferencesService } from '../services/sections/job/preferences.service';
import { UserContactInfo } from '../models/user-contact-info.model';
import { CustomerPreferences } from '../models/preferences.model';
import { PageType } from '../models/enum/page-type.enum';

@Injectable({
	providedIn: 'root'
})
export class CustomerPreferencesResolver implements Resolve<Observable<{ customers: UserContactInfo[], preferences: CustomerPreferences }>> {

	constructor(
		private router: Router,
		private preferencesService: PreferencesService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return forkJoin([
			this.preferencesService.getCustomerUsers(activatedRouteSnapshot.paramMap.get('token')),
			this.preferencesService.getPreferences(activatedRouteSnapshot.paramMap.get('token'))
		])
			.pipe(
				catchError((e) => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				}),
				tap(([customers, preferences]) => {
					if (activatedRouteSnapshot.data.pageType === PageType.Customer) {
						GlobalSettingsService.preferencesPayload.customers = customers;
						GlobalSettingsService.preferencesPayload.preferences = preferences;
						GlobalSettingsService.preferencesPayload.token = activatedRouteSnapshot.paramMap.get('token');
						GlobalSettingsService.preferencesPayload.pageType = activatedRouteSnapshot.data.pageType;

						// GlobalSettingsService.navigationBarActions.set(
						// 	'settingsModalOpen',
						// 	{
						// 		icon: 'settings',
						// 		listOrder: 1,
						// 		action: () => GlobalSettingsService.openPreferencesModal()
						// 	}
						// );
					}
				}),
				map(([customers, preferences]) => ({
					customers,
					preferences
				}))
			);
	}
}
